export const FIELDS = {

  ID: 'id',
  COMPANY_ID: 'companyId',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  ACCOUNT_NUMBER: 'accountNumber',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  COMPANY_NAME: 'companyName',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  CREATED_BY_USER_NAME: 'createdByUserName',
  MODIFIED_BY_USER_NAME: 'modifiedByUserName',
};